import React from "react";
import { Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { Dealer } from "../../../dtos/dealer";
import { ResponsiveDataView, Column } from "../../shared/ResponsiveDataView";

import { DealerRowActions } from "./DealerRowActions";

interface Props {
    dealers: Dealer[];
    onLoadDealers: () => void;
    dealersAreLoading: boolean;
}

const countLink = (dealerId: number, resource: string, count: number) =>
    count > 0 ? (
        <Link component={RouterLink} to={`/dealers/${dealerId}/${resource}`}>
            {count}
        </Link>
    ) : (
        <>{count}</>
    );

export const DealersTable = ({
    dealers,
    onLoadDealers,
    dealersAreLoading,
}: Props) => {
    const columns: Column<Dealer>[] = [
        { key: 'name', label: 'Name', primary: true },
        { key: 'numberOfOrgs', label: '# of Organizations', render: (d) => countLink(d.id, 'organizations', d.numberOfOrgs) },
        { key: 'numberOfSites', label: '# of Sites', render: (d) => countLink(d.id, 'sites', d.numberOfSites) },
        // No dealer-level customers endpoint; show the count as plain text so we don't lie about the link target.
        { key: 'numberOfCustomers', label: '# of Customers' },
        { key: 'numberOfEmployees', label: '# of Employees', render: (d) => countLink(d.id, 'employees', d.numberOfEmployees) },
    ];

    const rowActions = (d: Dealer) => (
        <DealerRowActions
            dealer={d}
            onLoadDealers={onLoadDealers}
            dealersAreLoading={dealersAreLoading}
        />
    );

    return (
        <ResponsiveDataView
            rows={dealers}
            columns={columns}
            rowKey={(d) => d.id}
            actions={rowActions}
            isInactive={(d) => !!d.isInactive}
            loading={dealersAreLoading}
        />
    );
};
